import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from '../../_css/Pricing.module.css';
import { ADMIN_TABS } from './mockData';

export default function AdminTabs() {
  return (
    <div className={styles.adminTabs}>
      {ADMIN_TABS.map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.path}
          className={({ isActive }) =>
            `${styles.adminTab} ${isActive ? styles.adminTabActive : ''}`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}
